import React from "react";
import Modal from "react-modal";
import theme, {
  roundness,
  styles as commonStyles,
} from "../../../utils/styles";

const cardWidth = commonStyles.videos().cardWidth * 3;
const iframePadding = 10;
const iframeWidth = cardWidth - iframePadding * 2;
const iframeHeight = (iframeWidth * 9) / 16;

const Dialog = (props) => {
  const { open, setOpen, isBreakpoint } = props;
  const { video, index } = props;
  const { name, link } = video;
  const id = index + "-" + name;

  const renderFacebookIframe = link.includes("facebook.com") ? (
    <iframe
      src={`https://www.facebook.com/plugins/video.php?href=${link}`}
      id={id}
      title={id}
      width={isBreakpoint ? "100%" : iframeWidth}
      height={isBreakpoint ? "100%" : iframeHeight}
      style={styles.iframe}
      scrolling="no"
      frameBorder={0}
      allowtransparency="true"
      allowFullScreen={true}
    />
  ) : null;

  const renderYoutubeIframe = link.includes("youtube.com") ? (
    <iframe
      src={link}
      id={id}
      title={id}
      width={isBreakpoint ? "100%" : iframeWidth}
      height={isBreakpoint ? "100%" : iframeHeight}
      style={styles.iframe}
      scrolling="no"
      frameBorder={0}
      allowtransparency="true"
      allowFullScreen={true}
    />
  ) : null;

  const renderCard = (
    <div style={styles.root}>
      {renderFacebookIframe}
      {renderYoutubeIframe}
    </div>
  );

  const closeModal = () => setOpen(false);

  return (
    <Modal isOpen={open} onRequestClose={closeModal} style={modalStyles}>
      {renderCard}
    </Modal>
  );
};

const modalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",

    background: theme.colors.backgroundFaded,
    borderRadius: roundness.card,

    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
  },
};

const styles = {
  iframe: {
    border: "none",
    overflow: "hidden",
  },
};

export default Dialog;
